import { render, staticRenderFns } from "./ProjectComponent.vue?vue&type=template&id=0cca0d40&"
import script from "./ProjectComponent.vue?vue&type=script&lang=js&"
export * from "./ProjectComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports